// removed by extract-text-webpack-plugin
module.exports = {"productSectionContainer":"productSectionContainer__3jszD","productSectionOuterContainer":"productSectionOuterContainer__2bXjI","leftSection":"leftSection__YYSTk","rightSection":"rightSection__dOusR","textPrimary":"textPrimary__X3fxL","textSecondary":"textSecondary__23bK-","eligibilityBtnContainer":"eligibilityBtnContainer__1kOuG"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVMerchant/productSection/style.css
// module id = 7eqH
// module chunks = 459